module.exports = __webpack_public_path__ + "img/cf.081aa72e.svg";